import { initFederation } from '@angular-architects/native-federation-v4';
import { setExtensionRemoteLoader } from './app/core/extensions/extension-remote-loader';

initFederation({}, { logLevel: 'error' })
  .then((federation) => {
    const initializedRemotes = new Map<string, Promise<typeof federation>>();

    setExtensionRemoteLoader(async <T = unknown>(
      remoteEntry: string,
      remoteName: string,
      exposedModule: string,
    ): Promise<T> => {
      const key = `${remoteName}|${remoteEntry}`;
      let initialization = initializedRemotes.get(key);

      if (!initialization) {
        initialization = federation.initRemoteEntry(remoteEntry, remoteName);
        initializedRemotes.set(key, initialization);
      }

      try {
        const runtime = await initialization;
        return runtime.loadRemoteModule<T>(remoteName, exposedModule);
      } catch (error) {
        initializedRemotes.delete(key);
        throw error;
      }
    });
  })
  .catch((error) => {
    setExtensionRemoteLoader(undefined);
    console.error('[extensions] Native Federation initialization failed.', error);
  })
  .then(() => import('./bootstrap'))
  .catch((error) => console.error(error));
